/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Table_Emptystate_Description2Inputs */

const en_settings_casmanagement_table_emptystate_description2 = /** @type {(inputs: Settings_Casmanagement_Table_Emptystate_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are currently no CAS templates configured for your funds.`)
};

/**
* | output |
* | --- |
* | "There are currently no CAS templates configured for your funds." |
*
* @param {Settings_Casmanagement_Table_Emptystate_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_table_emptystate_description2 = /** @type {((inputs?: Settings_Casmanagement_Table_Emptystate_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Table_Emptystate_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_table_emptystate_description2(inputs)
});
export { settings_casmanagement_table_emptystate_description2 as "settings_casManagement_table_emptyState_description" }